// extracted by mini-css-extract-plugin
module.exports = {"parameters":"CardParameters_parameters__c0_EN","card":"CardParameters_card__wn0Xe","emphasized":"CardParameters_emphasized__HPvBO"};